/**
 * Shared constants for the customer Lane Booking page and its dialog
 * components. Kept separate so each dialog file can import without
 * pulling in the parent's 1000+ lines.
 */

export const DURATION_OPTIONS = [
  { value: '30', label: '30 minutes' },
  { value: '60', label: '1 hour' },
  { value: '90', label: '1.5 hours' },
  { value: '120', label: '2 hours' },
];

export const LANE_COLORS = {
  '1': 'bg-blue-100 border-blue-300 text-blue-800',
  '2': 'bg-green-100 border-green-300 text-green-800',
  '3': 'bg-purple-100 border-purple-300 text-purple-800',
  '4': 'bg-orange-100 border-orange-300 text-orange-800',
};
